export default __webpack_public_path__ + "static/media/volkswagen-terminal.117e8a50.png";